module.exports = __webpack_public_path__ + "img/mir.a6db228b.svg";